import { defineManifest } from "@tc/sdk";
/** The set-up tool's questions (29/10/26): what a late day or delivery sign-off gives, by how sites are run (questions.ts). */
const QUESTIONS = [
    {
        id: "crs-company", ask: "A company-run site doesn't agree its day in time. What happens?",
        when: { operatingModel: ["company"] },
        options: [
            { value: "strike", label: "A strike", help: "Recorded and shown to the manager. No money." },
            { value: "off", label: "Nothing" },
        ],
    },
    {
        id: "crs-other", ask: "A commission or operator site doesn't agree its day in time. What happens?",
        when: { operatingModel: ["commission", "operator"] },
        options: [
            { value: "25", label: "Charge £25" },
            { value: "50", label: "Charge £50" },
            { value: "off", label: "Nothing" },
        ],
    },
    {
        id: "delivery", ask: "A fuel delivery isn't signed off in time. What happens?",
        when: { fuel: true },
        options: [
            { value: "on", label: "Charge £30", help: "A strike at company-run sites." },
            { value: "off", label: "Nothing" },
        ],
    },
];
export const manifest = defineManifest({
    id: "fines",
    name: "Charges",
    basePath: "/charges",
    version: "0.2.0",
    tier: "addon",
    accent: "cash",
    dependsOn: ["sites", "cash-office"],
    description: "Your own charge types, amounts and triggers: days not signed off in time, late fuel price changes and late delivery sign-offs charged automatically from the first offence, manual charges with a reason. Charges are charged on the site's day, agreed or queried there, and land on the invoice. Company-operated sites get strikes instead of charges.",
    permissions: {
        view: "See charges for your sites",
        issue: "Issue, change and cancel charges",
        settings: "Charge types, amounts, deadlines and which are switched on",
    },
    grants: {
        "Head office": ["view", "issue", "settings"],
        "Area manager": ["view", "issue"],
        "Site manager": ["view"],
    },
    questions: QUESTIONS,
    widgets: [
        { key: "fines", title: "Charges and strikes", description: "Charges and strikes in the last 30 days by site, and queries waiting for an answer.", group: "Cash office", size: 1, permission: "view", defaultOn: true, order: 56 },
    ],
    nav: [
        { label: "Charges", path: "/charges", section: "cash", tab: "Charges", tabIcon: "flag", permission: "view", icon: "flag", order: 62, blurb: "Charges and strikes at your sites, and any queries on them" },
    ],
});
